export const baseUri = process.env.VUE_APP_BASE_URI || `http://localhost:8000/api/`
export const accessToken = process.env.VUE_APP_TOKEN
export const defaultSavedConfig = process.env.VUE_APP_DEFAULT_SAVED
export const backendUrl = process.env.VUE_APP_API_HOST
export const sshrDomain = process.env.VUE_APP_SSHR_DOMAIN
export const midtransConfig = {
  key: process.env.VUE_APP_MIDTRANS_KEY,
  lib: process.env.VUE_APP_MIDTRANS_LIB
}

export const v2 = `v2`

const config = {
  baseUri,
  accessToken,
  defaultSavedConfig,
  backendUrl,
  midtransConfig,
  v2,
  sshrDomain
}
export default config
